export const formatBoatName = (name: string) => {
  return name
    .replace(/[/#%]/g, '') // Remove only specific problematic characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .toLowerCase(); // Convert to lowercase
};
